import React, { useState, useEffect } from 'react';
import { TagIcon } from 'lucide-react';
import { theme } from '../config/theme';
import { getPromoBannerStatus } from '../services/api';

interface PromoBannerProps {}

const PromoBanner: React.FC<PromoBannerProps> = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [promoText, setPromoText] = useState('');
  const [promoCode, setPromoCode] = useState('');

  useEffect(() => {
    const fetchBannerSettings = async () => {
      try {
        const bannerStatus = await getPromoBannerStatus();
        
        if (bannerStatus.enabled) {
          setIsVisible(true);
          setPromoText(bannerStatus.text || '');
          setPromoCode(bannerStatus.code || '');
        }
      } catch (error) {
        // Handle errors gracefully - hide banner if can't fetch status
        console.error('Promo banner: Could not fetch banner status');
        setIsVisible(false);
      }
    };

    fetchBannerSettings();
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div 
      className="relative py-3 px-4"
      style={{ 
        backgroundColor: theme.colors.primary[700],
        color: theme.colors.text.inverse 
      }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center">
        <div className="flex items-center space-x-3">
          <TagIcon className="h-5 w-5" style={{ color: theme.colors.primary[100] }} />
          <p className="text-sm md:text-base font-medium">
            {promoText}
            {promoCode && (
              <span 
                className="ml-2 px-3 py-1 rounded-md font-bold text-sm"
                style={{ 
                  backgroundColor: theme.colors.primary[900],
                  color: theme.colors.primary[100]
                }}
              >
                {promoCode}
              </span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
